import styled from "styled-components";

export const DisclosureBody = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: var(--spacing-4);
    padding: var(--spacing-3);

    @supports not (padding-inline: 0) {
        & > div:not(:nth-last-child(1)) {
            margin-bottom: var(--spacing-4);
        }
    }
`;

export const ReservationProcessList = styled.ol`
    margin: 0;
    padding: 0;
    list-style-type: none;
    counter-reset: li;

    li {
        position: relative;
        padding: var(--spacing-3) var(--spacing-3) var(--spacing-3) 76px;
        font-family: var(--font-regular);
        font-size: 1.6rem;
        line-height: 2.4rem;
        color: var(--color-midnight);
        background-color: var(--color-cloud);
        border-radius: 4px;

        &:not(:only-child):not(:nth-last-child(1)) {
            margin-bottom: calc(var(--spacing-3) / 2) !important;
        }

        &::before {
            display: flex;
            position: absolute;
            inset-block-start: 50%;
            inset-inline-start: var(--spacing-3);
            align-items: flex-start;
            justify-content: center;
            width: 34px;
            height: 34px;
            padding-block: 6px;
            padding-inline: var(--spacing-1);
            font-family: var(--font-regular);
            font-size: 1.6rem;
            line-height: 2.4rem;
            color: var(--color-white);
            counter-increment: li;
            content: counter(li);
            background-color: var(--color-azure);
            border-radius: 50%;
            transform: translateY(-50%);
        }
    }

    &:not(:only-child) {
        margin-bottom: var(--spacing-3);
    }
`;
